import { StickyNote } from "lucide-react";
import { HotLeads } from "@/components/HotLeads";
import { fmtDateTime } from "@/lib/format";

const OUTCOME_STATUSES = ["contacted", "won", "lost", "closed"];
const OUTCOME_STYLE = { won: "text-emerald-400", lost: "text-red-400", closed: "text-[#A8A29E]", contacted: "text-emerald-400" };

export const AdminQuotesTab = ({ quotes, onReload, onOpen }) => (
  <>
    <HotLeads onChanged={onReload} onOpen={onOpen} />
    <div className="tacc-card overflow-x-auto" data-testid="admin-quotes-table">
      <table className="w-full text-sm min-w-[820px]">
        <thead>
          <tr className="text-left font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] border-b border-[#E7DFD5]">
            <th className="p-4">Date</th><th className="p-4">Company</th><th className="p-4">Contact</th><th className="p-4">Email</th><th className="p-4">Size</th><th className="p-4">Tier</th><th className="p-4">Notes</th>
          </tr>
        </thead>
        <tbody>
          {quotes.map((q) => (
            <tr key={q.id} onClick={() => onOpen(q)} className="border-b border-[#E7DFD5] hover:bg-[#F59E0B]/[0.06] cursor-pointer transition-colors" data-testid={`admin-quote-row-${q.id}`} title="Open this quote">
              <td className="p-4 text-[#78716C] whitespace-nowrap">{fmtDateTime(q.created_at)}</td>
              <td className="p-4 text-[#1C1917] underline decoration-[#F59E0B]/40 underline-offset-4">{q.company_name}</td>
              <td className="p-4">{q.contact_name}</td>
              <td className="p-4 text-[#78716C]">{q.work_email}</td>
              <td className="p-4 text-[#78716C]">{q.company_size}</td>
              <td className="p-4 capitalize" data-testid={`admin-quote-status-${q.id}`}>
                {OUTCOME_STATUSES.includes(q.status)
                  ? <span className={`font-mono text-[10px] tracking-[0.2em] uppercase ${OUTCOME_STYLE[q.status]}`}>{q.status}</span>
                  : (q.tier || "—")}
              </td>
              <td className="p-4" data-testid={`admin-quote-notes-${q.id}`} title={q.last_note?.text || "No notes yet"}>
                {q.notes_count ? <span className="inline-flex items-center gap-1 text-[#B45309] text-xs"><StickyNote size={12} /> {q.notes_count}</span> : <span className="text-[#555]">—</span>}
              </td>
            </tr>
          ))}
          {quotes.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-[#78716C]">No quotes yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </>
);
